
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import AppViewColumns from "@/components/view-editor/Columns.vue";
import AppViewFilters from "@/components/view-editor/Filters.vue";
import AppDuplicateViewModal from "@/components/view-editor/DuplicateViewModal.vue";
import AppHighlights from "./Highlights.vue";
import AppViewSidebar from "./Sidebar.vue";
import { View } from "@/models/view";
import { ViewService } from "@/services/view-service";
import Vue from "vue";
import { AsyncComponentPromise } from "vue/types/options";
import AppTotals from "./Totals.vue";
import { AuthService } from "@/services";

export default Vue.extend({
	data() {
		return {
			currentTab: 0,
			metaDataEditComponent: undefined as undefined | AsyncComponentPromise,
			showDuplicateViewModal: false,
			nameFieldWasFocused: false
		};
	},
	props: {
		view: {
			type: Object as () => View,
			required: true
		}
	},
	computed: {
		tabs(): string[] {
			return["columns", "filters", "totals", "highlights", "sidebar-tab"].map(t=>this.$ct(t).toString());
		},
		currentLang(): string {
			return this.$i18n.locale;
		},
		editLang(): string {
			return this.currentLang || "nl-be";
		},
		saveDisabled():boolean {
			if (this.view.UserID != AuthService.wfUser.ID){
				return true;
			}

			return !this.view.isValid();
		},
		showNoViewNameError():boolean {
			if ( this.view.Name.trim() != "") return false;
			if (this.view.ID != 0) return true;
			if (this.nameFieldWasFocused) return true;
			return false;
		}
	},
	methods: {
		async save() {
			if (this.view.ID != 0) {
				await ViewService.updateView(this.view);
			} else {
				await ViewService.createView(this.view);
			}
			this.$router.back();
		},
		getViewMetaDataEditors(browseId:number):AsyncComponentPromise | undefined{
			// sales
			if (browseId == 6){
				return ()=>import("@/components/view-editor/SalesMetaDataEdit.vue");
			}
			if (browseId == 8){
				return ()=>import("@/components/view-editor/BankMetaDataEdit.vue");
			}
			return undefined;
		},
		async showDuplicateViewModalPopUp() {
			this.showDuplicateViewModal = true;
		},
		async duplicateView(event: View) {
			this.showDuplicateViewModal = true;
			if (!event) {
				this.$wf.notify(this.$ct("common.notifications.title-default-error",{Props: "dupliceren van deze view"}).toString(), "warning", 3500, "exclamation-triangle");
				return;
			}
			event.UserID = AuthService.wfUser.ID;
			await ViewService.createView(event);
			this.$router.back();
		},
	},
	mounted(){
		if (this.$route.query.tab == "sidebar") {
			this.currentTab = 4;
		}
		this.metaDataEditComponent = this.getViewMetaDataEditors(this.view.BrowseID);
		if (this.view.UserID !== 0 && (this.view.UserID != AuthService.wfUser.ID)){
			this.$wf.notify(this.$ct("only-owners-can-edit"), "danger", 3000, "exclamation-triangle");
		}
	},
	components: {
		AppViewColumns,
		AppViewFilters,
		AppMobileFullScreenContainer,
		AppToolbar,
		AppDuplicateViewModal,
		AppTotals,
		AppHighlights,
		AppViewSidebar
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
